<template>
	<vs-prompt
		:active.sync="activePrompt"
		:title="$t('changeStatusTaskTitle')"
		@accept="accept"
		:acceptText="$t('yes')"
		:cancelText="$t('cancel')"
		color="primary"
	>
		<div>
			{{ $t('doYouWantDeleteTask') }}
		</div>
	</vs-prompt>
</template>

<script>
export default {
	name: "ModalDeleteTask",
	props: {
		active: {
			required: true,
			type: Boolean
		},
	},
	computed: {
		activePrompt: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
			}
		}
	},
	methods: {
		accept() {
			this.activePrompt = false;
			this.$emit("accept");
		},
	}
};
</script>

<style>

</style>